import { get, post } from "../GenericServices";

const AccountingBookPlanning = {
  getPlanning: (year) => {
    return get(`accounting-book-planning/list/${year}`);
  },
  getPlanningDetail: (yearMonth) => {
    return get(`accounting-book-planning/${yearMonth}`);
  },
  savePlanning: (yearMonth, data) => {
    return post(`accounting-book-planning/${yearMonth}`, data);
  },
  downloadPlanningDetail: (yearMonth) => {
    return get(`accounting-book-planning/download-document/${yearMonth}`, {}, "blob");
  },
  downloadPlanningIndex: (yearMonth) => {
    return get(`accounting-book-planning/download-index/${yearMonth}`, {}, "blob");
  },
  getProgressive: (year) => {
    return get(`accounting-book-planning/progress/${year}`);
  },
};

export default AccountingBookPlanning;
